import { EnumAutoCreationDocumentTypes, EnumCustomerAddressTypes, EnumDeliveryMethods, EnumInvoicePaymentTypes, EnumPaymentRequestStatuses, EnumPaymentRequestSteps, EnumPaymentRequestTypes, EnumSystemTypes, EnumDocumentFilteringOption } from "@dato-proxy/enums";
import { EnumLanguages } from '@m4u-angular/core/framework/sysenums.enum';

export const Lists_HE =
{
    Properties:
    {
        Language: EnumLanguages.Hebrew
    },


    LedgerIsOpenStatuses:
        [
            {
                Text: 'פתוח',
                Value: true
            },
            {
                Text: 'סגור',
                Value: false
            }
        ],
    InvoicePaymentStatuses:
        [
            {
                Text: 'לא שולם',
                Value: EnumInvoicePaymentTypes.NotPaid
            },
            {
                Text: 'שולם חלקית',
                Value: EnumInvoicePaymentTypes.PaidPartially
            },
            {
                Text: 'שולם',
                Value: EnumInvoicePaymentTypes.Paid
            },
            {
                Text: 'זיכוי',
                Value: EnumInvoicePaymentTypes.OutstandingCredit
            },
            {
                Text: 'פתוח',
                Value: EnumInvoicePaymentTypes.Open
            },
            {
                Text: 'סגור',
                Value: EnumInvoicePaymentTypes.Closed
            }
        ],
    ChoiseCardByPayment:
        [
            {
                Text: 'השתמש בכרטיס אשראי קיים המסתיים ב {0}',
                Value: 'Old',
                SortOrder: 0
            },
            {
                Text: 'הזן כרטיס אשראי חדש',
                Value: 'New',
                SortOrder: 1
            }
        ],
    ReportTabs:
        [
            {
                index: 0,
                text: 'כרטסת',
                Type: 0
            },
            {
                index: 1,
                text: 'דוח מסמכים',
                Type: 1
            },
            {
                index: 2,
                text: 'דוח גיול',
                Type: 2
            },
            {
                index: 3,
                text: 'תעודות משלוח',
                Type: 3
            },
        ],
    ReportTabsLandLord:
        [
            {
                index: 0,
                text: 'כרטסת',
                Type: 0
            },
            {
                index: 1,
                text: 'דוח מסמכים',
                Type: 1
            },
            {
                index: 2,
                text: 'דוח גיול',
                Type: 2
            },
            {
                index: 3,
                text: 'דרישות תשלום',
                Type: 3
            },
        ],
    ReportTabsZulu:
        [
            {
                index: 0,
                text: 'כרטסת',
                Type: 0
            },
            {
                index: 1,
                text: 'דוח מסמכים',
                Type: 1
            },
            {
                index: 2,
                text: 'דוח גיול',
                Type: 2
            },
            {
                index: 3,
                text: 'תעודות משלוח',
                Type: 3
            },
        ],
    CustomerAddressTabs:
        [
            {
                index: 1,
                text: 'כתובות לחיוב',
                Value: EnumCustomerAddressTypes.Bill,
                Name: 'BillCustomerAddresses'
            },
            {
                index: 0,
                text: 'כתובות למשלוח',
                Value: EnumCustomerAddressTypes.Ship,
                Name: 'ShipCustomerAddresses'
            }
        ],
    AutoCreationDocumentType: [
        {
            SortOrder: 1,
            Text: 'חשבונית מס',
            Value: EnumAutoCreationDocumentTypes.Invoice
        }, {
            SortOrder: 2,
            Text: 'הזמנה',
            Value: EnumAutoCreationDocumentTypes.Order
        }, {
            SortOrder: 3,
            Text: 'ללא',
            Value: EnumAutoCreationDocumentTypes.None
        }
    ],
    PaymentRequestStatuses: [
        {
            SortOrder: 1,
            Text: 'ניסיון תשלום',
            Value: EnumPaymentRequestStatuses.Sent
        }, {
            SortOrder: 2,
            Text: 'כרטיס אשראי שונה',
            Value: EnumPaymentRequestStatuses.Confirmed
        }, {
            SortOrder: 3,
            Text: 'שולם',
            Value: EnumPaymentRequestStatuses.Executed
        }, {
            SortOrder: 4,
            Text: 'שגיאה בזמן תשלום',
            Value: EnumPaymentRequestStatuses.Error
        }, {
            SortOrder: 5,
            Text: 'נדרשת התערבות ידנית',
            Value: EnumPaymentRequestStatuses.Cancelled
        }, {
            SortOrder: 6,
            Text: 'טופל ידני',
            Value: EnumPaymentRequestStatuses.Resolved
        }
    ],
    PaymentRequestTypes: [
        {
            SortOrder: 1,
            Text: 'כרטיס קיים',
            Value: EnumPaymentRequestTypes.PaymentByExistingCard
        }, {
            SortOrder: 2,
            Text: 'כרטיס חדש',
            Value: EnumPaymentRequestTypes.PaymentByNewCard
        }, {
            SortOrder: 3,
            Text: 'פייפאל',
            Value: EnumPaymentRequestTypes.Paypal
        }, {
            SortOrder: 4,
            Text: 'ביט',
            Value: EnumPaymentRequestTypes.Bit
        }
    ],
    PaymentRequestSteps: [
        {
            SortOrder: 1,
            Text: 'שליחה',
            Value: EnumPaymentRequestSteps.SendToPaymentService
        }, {
            SortOrder: 2,
            Text: 'אישור תשלום',
            Value: EnumPaymentRequestSteps.ConfirmInPaymentService
        }, {
            SortOrder: 3,
            Text: 'תשלום',
            Value: EnumPaymentRequestSteps.ExecuteInPaymentService
        }, {
            SortOrder: 4,
            Text: 'יצירת חשבונית מס',
            Value: EnumPaymentRequestSteps.SaveInvoice
        }, {
            SortOrder: 5,
            Text: 'יצירת הזמנה',
            Value: EnumPaymentRequestSteps.SaveOrder
        }, {
            SortOrder: 6,
            Text: 'יצירת קבלה',
            Value: EnumPaymentRequestSteps.SaveReceipt
        }, {
            SortOrder: 7,
            Text: 'עדכון ת. אסמכתא תנועת יומן',
            Value: EnumPaymentRequestSteps.UpdateTransactionRefDataInPaymentService
        }, {
            SortOrder: 8,
            Text: 'שמירת כרטיס אשראי',
            Value: EnumPaymentRequestSteps.SaveCreditCard
        }, {
            SortOrder: 9,
            Text: 'שליחת חשבונית',
            Value: EnumPaymentRequestSteps.SendInvoice
        }, {
            SortOrder: 10,
            Text: 'שליחת הזמנה',
            Value: EnumPaymentRequestSteps.SendOrder
        }, {
            SortOrder: 11,
            Text: 'שליחת קבלה',
            Value: EnumPaymentRequestSteps.SendReceipt
        }, {
            SortOrder: 12,
            Text: 'ביטול תשלום',
            Value: EnumPaymentRequestSteps.Rollback
        }, {
            SortOrder: 13,
            Text: 'שליחת התראה לאדמין',
            Value: EnumPaymentRequestSteps.AdminNotificationSent
        }, {
            SortOrder: 14,
            Text: 'מעבר למערכת תשלום',
            Value: EnumPaymentRequestSteps.TransferedToPaymentService
        }
    ],
    SystemTypes: [
        {
            SortOrder: 1,
            Text: 'סאפ',
            Value: EnumSystemTypes.SBO
        }, {
            SortOrder: 2,
            Text: 'נכסים',
            Value: EnumSystemTypes.Landlord
        }, {
            SortOrder: 3,
            Text: 'זולו',
            Value: EnumSystemTypes.Zulu
        }
    ],
    MyDetailsTabs: [
        {
            index: 0,
            text: "אנשי קשר",
            Name: 'ContactPersons'
        },
        {
            index: 1,
            text: "כתובות",
            Name: 'CustomerAddresses'
        }
    ],
    DeliveryMethods: [
        {
            SortOrder: 1,
            Text: 'אימייל',
            Value: EnumDeliveryMethods.Email
        },
        {
            SortOrder: 2,
            Text: 'הודעת SMS',
            Value: EnumDeliveryMethods.Phone
        },
        {
            SortOrder: 3,
            Text: 'WhatsApp',
            Value: EnumDeliveryMethods.WhatsApp
        }
    ],
    DocumentFilteringOption: [
        {
            SortOrder: 1,
            Text: 'הצג פתוחים',
            Value: EnumDocumentFilteringOption.ShowOpen
        }, {
            SortOrder: 2,
            Text: 'הצג כולם',
            Value: EnumDocumentFilteringOption.ShowAll
        }, {
            SortOrder: 3,
            Text: 'אוטומטי',
            Value: EnumDocumentFilteringOption.Automatic
        }
    ]
};
